import LibraryConfiguration from './LibraryConfiguration';

export default LibraryConfiguration;
